import {Injectable} from "@angular/core";
import {UserService} from "@ispm/user/services/user.service";
import {ActivatedRouteSnapshot} from "@angular/router";

@Injectable({providedIn: 'root'})
export class patientResolver {
  constructor(private userService: UserService) {
  }
  resolve(activatedRouteSnapshot: ActivatedRouteSnapshot) {
    return this.userService.getPatient(activatedRouteSnapshot.params.patientId);
  }
}
